import { Component, OnInit } from '@angular/core';
import { Veroispovest } from './veroispovest';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-veroispovest-modal-update',
  templateUrl: './veroispovest-modal-update.component.html'
})
export class VeroispovestModalUpdateComponent extends BaseModalUpdateComponent<Veroispovest> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Veroispovest>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
